import { uniqueDirectoryRecords } from "../utils/directoryOptions";
import {
  API_FleetDirectory_locations,
  API_FleetDirectory_partners,
  API_FleetDirectory_shared_search,
  API_REQUEST_HEADERS_BASEURL,
} from "../utils/Constants";

const endpoint = (template, fleetId) => template.replace("{fleetId}", fleetId);

export async function listDirectoryPartners(fleetId, params = {}) {
  const response = await API_REQUEST_HEADERS_BASEURL.get(endpoint(API_FleetDirectory_partners, fleetId), { params });
  return uniqueDirectoryRecords(response.data?.data || []);
}

export async function listDirectoryPartnersPage(fleetId, params = {}) {
  const response = await API_REQUEST_HEADERS_BASEURL.get(endpoint(API_FleetDirectory_partners, fleetId), {
    params: { ...params, paginate: true },
  });
  return { items: response.data?.data || [], pagination: response.data?.pagination || {} };
}

export async function saveDirectoryPartner(fleetId, value) {
  const base = endpoint(API_FleetDirectory_partners, fleetId);
  const response = value.id
    ? await API_REQUEST_HEADERS_BASEURL.patch(`${base}/${value.id}`, value)
    : await API_REQUEST_HEADERS_BASEURL.post(base, value);
  return response.data?.data;
}

export async function setDirectoryPartnerFavorite(fleetId, partnerId, favorite) {
  const base = endpoint(API_FleetDirectory_partners, fleetId).replace(/\/partners$/, "/partner-favorites");
  const response = await API_REQUEST_HEADERS_BASEURL.put(`${base}/${encodeURIComponent(partnerId)}`, { favorite });
  return response.data?.data;
}

export async function archiveDirectoryPartner(fleetId, partnerId) {
  const response = await API_REQUEST_HEADERS_BASEURL.delete(
    `${endpoint(API_FleetDirectory_partners, fleetId)}/${partnerId}`
  );
  return response.data?.data;
}

export async function listDirectoryLocations(fleetId, params = {}) {
  const response = await API_REQUEST_HEADERS_BASEURL.get(endpoint(API_FleetDirectory_locations, fleetId), { params });
  return uniqueDirectoryRecords(response.data?.data || []);
}

export async function listDirectoryLocationsPage(fleetId, params = {}) {
  const response = await API_REQUEST_HEADERS_BASEURL.get(endpoint(API_FleetDirectory_locations, fleetId), {
    params: { ...params, paginate: true },
  });
  return { items: response.data?.data || [], pagination: response.data?.pagination || {} };
}

export async function setDirectoryLocationFavorite(fleetId, placeId, favorite) {
  const response = await API_REQUEST_HEADERS_BASEURL.put(
    `${endpoint(API_FleetDirectory_locations, fleetId).replace(/\/locations$/, "/location-favorites")}/${placeId}`,
    { favorite }
  );
  return response.data?.data;
}

export async function saveDirectoryLocation(fleetId, value) {
  const base = endpoint(API_FleetDirectory_locations, fleetId);
  const response = value.id
    ? await API_REQUEST_HEADERS_BASEURL.patch(`${base}/${value.id}`, value)
    : await API_REQUEST_HEADERS_BASEURL.post(base, value);
  return response.data?.data;
}

export async function archiveDirectoryLocation(fleetId, locationId) {
  const response = await API_REQUEST_HEADERS_BASEURL.delete(
    `${endpoint(API_FleetDirectory_locations, fleetId)}/${locationId}`
  );
  return response.data?.data;
}

export async function searchSharedDirectory(fleetId, query, type) {
  const response = await API_REQUEST_HEADERS_BASEURL.get(
    endpoint(API_FleetDirectory_shared_search, fleetId),
    { params: { query, type, limit: 30 } }
  );
  return uniqueDirectoryRecords(response.data?.data || []);
}
